module.exports = __webpack_public_path__ + "media/images/badge/tifoso_secondary-39b1c48f8f79f44e407f810b93ae913c.png";